<app-segov-sigepo-portal-body>
  <div class="default-spacing-title">
    <app-segov-sigepo-pesquisa-form (dadosPesquisaFormOutput)="efetuarPesquisa($event)"/>
  </div>

  <div style="justify-content: center; width: 100%;">
  @if(dadosPesquisa) {
    <div id="resultado-pesquisa" class="default-spacing-title">
      <h1 style="color: var(--tom-2-jornal)">Resultado da pesquisa</h1>
      <h4 class="titulo-resultado-pesquisa-jornal mb-5 mb-sm-3"><strong class="titulo-resultado-highlight">{{totalRegistros}}</strong> resultados encontrados para <strong>{{textoPesquisa}}</strong>, no período de {{dataInicial | date: 'dd/MM/yyyy'}} até {{dataFinal | date: 'dd/MM/yyyy'}}</h4>

      @if(totalRegistros > 0) {
        @for(item of dadosPesquisa; track $index){
          <app-card-dados-publicacao (downloadIdOutput)="downloadPublicacao($event)" [textoPesquisa]="textoPesquisa" [dadosJornal]="item" [segundoTomDeFundo]="$index % 2 === 0"/>
        }

        <lib-segov-sigepo-pagination
        [style.display]="'flex'"
        [style.justify-content]="'center'"
        [currentPage]="currentPage"
        [totalPages]="totalPages"
        [pagesAroundCurrent]="1"
        (pageChange)="onPageChange($event)"/>
      } @else {
        <div style="background-color: var(--grey-400); padding: 2rem; border-radius: 2rem; margin: 2rem;">
          <span style="color: black">Nenhum registro encontrado</span>
        </div>
      }
    </div>
  }
  </div>
</app-segov-sigepo-portal-body>
